import rest from "../script/rest";

class IxusRest {

    async getImage(calculationId) {
        const url = "/rest/ixus/getImage"
            + "?calculationId=" + calculationId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getReportImage(entryId) {
        const url = "/rest/ixus/getReportImage"
            + "?entryId=" + entryId;
        const response = await rest.get(url);
        const json = await response.json();
        return json.value;
    }

    async getTextFieldOptions(ixusSetting) {
        const url = "/rest/ixus/getTextFieldOptions";
        const response = await rest.post(url, ixusSetting);
        const json = await response.json();
        return json.value;
    }

    async setReportImage(entryId, base64Image){
        const url = "/rest/ixus/setReportImage";

        const base64ImageParts = base64Image.split(",");
        // eslint-disable-next-line
        const contentType = base64ImageParts[0].split(":")[1];
        const rawImageData = window.atob(base64ImageParts[1]);
        const imageDataArray = new Uint8Array(rawImageData.length);
        for (let i = 0; i < rawImageData.length; i++) {
            imageDataArray[i] = rawImageData.charCodeAt(i);
        }
        const imageBlob = new Blob([imageDataArray], { type: contentType });

        const formData = new FormData();
        formData.append("file", imageBlob);
        formData.append("entryId", entryId);
        const response = await rest.form(url, formData);
        return response;
    }
}
const ixusRest = new IxusRest();
window.ixusRest = ixusRest;
export default ixusRest;